import { EducationInformation } from './EducationInformation';

export class EducationInstitutionDetail extends EducationInformation {
    degree: string;
}
